/** Represents a Custom Hierarchy. Keep synced with C# class located at ClearView WebPortal\AppCode\Api\Models\Pipeline\PipelineConfigurationModels.cs */
export class HierarchyModel {
    public CustomHierarchyID: number;
    public Name: string = "";    
    public SelectedLogins: LoginDTO[];
    public SelectedRoles: ProfileDTO[];
    public AggregationLevels: HierarchyAggregationLevel[];
}

/** Represents an Aggregation Level for a Custom Hierarchy. Keep synced with C# class located at ClearView WebPortal\AppCode\Api\Models\Pipeline\PipelineConfigurationModels.cs */
export class HierarchyAggregationLevel {
    public Name: string;
    public Position: number;
}

/** Represents a simplified Login for the Custom Hierarchy modal. Keep synced with C# class located at ClearView WebPortal\AppCode\Api\Models\Pipeline\PipelineConfigurationModels.cs */
export interface LoginDTO {
    LoginID: number;
    LoginName: string;    
}

/** Represents a simplified Profile (Role) for the Custom Hierarchy modal. Keep synced with C# class located at ClearView WebPortal\AppCode\Api\Models\Pipeline\PipelineConfigurationModels.cs */
export interface ProfileDTO {
    ProfileID: number;
    ProfileName: string;    
}

/** Initial load of the Custom Hierarchy page/modal. Contains a list of Custom Hierarchies as well as all possible Logins and Roles. 
 * Keep synced with C# class located at ClearView WebPortal\AppCode\Api\Models\Pipeline\PipelineConfigurationModels.cs
 */
export interface CustomHierarchyPageLoadModel {
    HierarchyModels: HierarchyModel[];
    AvailableLogins: LoginDTO[];
    AvailableRoles: ProfileDTO[];
}